import {
  HttpErrorResponse,
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';


/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private auth: AuthService, private as: AlertService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
     // Get the auth token from the service.
    const token = this.auth.getToken();

    let online = navigator.onLine;
    if(!online){
        this.as.toast("You are offline");
        return EMPTY;    
    }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    
    let authReq = req.clone({
      headers: 
        req.headers
        .set('Authorization', `Bearer ${token}`)
        .set('X-Tools-Version', '5.1.0')
    });

    if(req.url.includes("https://api.github.com")){
      return next.handle(req);
    }
    return next.handle(authReq)
  }
}

@Injectable()
export class AuthErrInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router:Router) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        this.router.navigate(['/login']);
        return throwError(error);
      }
      return throwError(error);
    }));
  }
}